import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiCheckboxClickAreaDirective } from './fi-checkbox-click-area.directive';

@NgModule({
    imports: [CommonModule, MatCheckboxModule],
    declarations: [FiCheckboxClickAreaDirective],
    exports: [FiCheckboxClickAreaDirective],
})
export class FiCheckboxClickAreaModule {}
